import { createSelector } from 'reselect';

// Actions
export const CONTACTS_TEST = 'contacts/CONTACTS_TEST';

// Initial state
const initialState = {
  helloWorld: false
};

// Reducers
export function contactsPageReducer(state = initialState, action) {
  switch (action.type) {
    case CONTACTS_TEST: {
      const newState = {
        ...state,
        helloWorld: true
      };

      return newState;
    }

    default: {
      return state;
    }
  }
}

// Action Creators
export function setHelloWorld() {
  return {
    type: CONTACTS_TEST
  };
}

// Selectors
export const getContactsState = createSelector(
  (state) => state,
  (state) => state.get('contacts')
);

export const getContactsHelloWorld = createSelector(
  getContactsState,
  (contactsState) => contactsState?.helloWorld
);



// WEBPACK FOOTER //
// ./src/redux/modules/contacts.js